(function () {
  const cfg = window.SALES_LOCK || {};
  if (!cfg.enabled || !cfg.deadline) return;

  const deadline = new Date(cfg.deadline);
  if (isNaN(deadline.getTime())) return;

  function isLocked() {
    return Date.now() < deadline.getTime();
  }

  function formatRemaining(ms) {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    const pad = (n) => String(n).padStart(2, "0");
    if (days > 0) return `${days}d ${pad(hours)}h ${pad(mins)}m ${pad(secs)}s`;
    return `${pad(hours)}h ${pad(mins)}m ${pad(secs)}s`;
  }

  function updateCountdown() {
    const locked = isLocked();
    const nodes = document.querySelectorAll("[data-sales-lock-countdown]");
    if (!nodes.length) return;

    if (!locked) {
      nodes.forEach((n) => (n.textContent = "00h 00m 00s"));
      return;
    }

    const ms = deadline.getTime() - Date.now();
    const text = formatRemaining(ms);
    nodes.forEach((n) => (n.textContent = text));
  }

  function hideElement(el) {
    if (!el) return;
    el.style.display = "none";
  }

  function disableElement(el) {
    if (!el) return;
    el.setAttribute("aria-disabled", "true");
    el.setAttribute("tabindex", "-1");
    el.style.pointerEvents = "none";
    el.style.opacity = "0.6";
    if ("disabled" in el) el.disabled = true;
  }

  function showLockMessageNear(target) {
    if (!target) return;

    // Avoid duplicates
    if (document.querySelector("[data-sales-lock-message]")) return;

    const box = document.createElement("div");
    box.setAttribute("data-sales-lock-message", "true");
    box.style.margin = "12px 0";
    box.style.padding = "12px 14px";
    box.style.borderRadius = "10px";
    box.style.border = "1px solid rgba(0,0,0,0.12)";
    box.style.background = "rgba(0,0,0,0.04)";
    box.style.fontSize = "14px";
    box.style.lineHeight = "1.4";
    box.innerHTML = `
      <div style="font-weight:600; margin-bottom:6px;">Sales countdown active</div>
      <div>${(cfg.cartText || "Checkout is disabled during the sales countdown.")}</div>
      <div style="margin-top:8px;">
        <span style="opacity:.8;">Sales start in: </span>
        <span data-sales-lock-countdown style="font-weight:600;"></span>
      </div>
    `;

    target.parentNode.insertBefore(box, target);
  }

  function applyLock() {
    if (!isLocked()) return;

    // 1) Hide dynamic checkout buttons (Shop Pay / Apple Pay / GPay)
    document.querySelectorAll(".shopify-payment-button, [data-shopify-buttoncontainer]").forEach(hideElement);

    // 2) Disable common checkout buttons/links
    const checkoutSelectors = [
      'button[name="checkout"]',
      'input[name="checkout"]',
      'a[href*="/checkout"]',
      'form[action="/checkout"] button',
      'button.checkout',
      '[data-checkout]',
      '.cart__checkout-button',
      '#checkout',
      '.cart__ctas button[type="submit"]'
    ];
    document.querySelectorAll(checkoutSelectors.join(",")).forEach(disableElement);

    // 3) Intercept clicks that still happen (some themes render different markup)
    document.addEventListener(
      "click",
      function (e) {
        if (!isLocked()) return;

        const t = e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-checkout]');
        if (!t) return;

        e.preventDefault();
        e.stopPropagation();

        // Try to show message near the clicked element (esp. cart page)
        showLockMessageNear(t);
        updateCountdown();
      },
      true
    );

    // 4) Intercept form submissions that try to go to checkout
    document.addEventListener(
      "submit",
      function (e) {
        if (!isLocked()) return;

        const form = e.target;
        if (!form) return;

        // If any form is attempting checkout, block
        const action = (form.getAttribute("action") || "").toLowerCase();
        if (action.includes("/checkout")) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    // 5) If on cart page, show a message near the checkout area (best-effort)
    const likelyCheckoutArea =
      document.querySelector('button[name="checkout"]') ||
      document.querySelector('a[href*="/checkout"]') ||
      document.querySelector(".cart__ctas") ||
      document.querySelector("form[action*='/cart']");
    showLockMessageNear(likelyCheckoutArea);
  }

  // Basic banner styles injected (you can move to CSS if you want)
  function injectStyles() {
    const css = `
      .sales-lock-banner{
        position: sticky;
        top: 0;
        z-index: 50;
        width: 100%;
        padding: 10px 16px;
        text-align: center;
        font-size: 14px;
        line-height: 1.3;
        background: rgba(0,0,0,0.85);
        color: #fff;
        backdrop-filter: blur(8px);
      }
      .sales-lock-banner__text{ opacity: .85; margin-right: 6px; }
      .sales-lock-countdown{ font-weight: 600; letter-spacing: .2px; }
    `;
    const style = document.createElement("style");
    style.textContent = css;
    document.head.appendChild(style);
  }

  injectStyles();
  applyLock();
  updateCountdown();
  setInterval(updateCountdown, 1000);
})();
